import { render } from "./ActivityFollowupEmail.vue?vue&type=template&id=1efb8b73&scoped=true"
import script from "./ActivityFollowupEmail.vue?vue&type=script&lang=js"
export * from "./ActivityFollowupEmail.vue?vue&type=script&lang=js"

import "./ActivityFollowupEmail.vue?vue&type=style&index=0&id=1efb8b73&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efb8b73"]])

export default __exports__